export default "__VITE_ASSET__CyIT_7WF__"